import React from 'react';
import { MailIcon, SettingsIcon } from 'lucide-react';
import { AccordionItem } from './Accordion';
import { OBJECTIONS } from '../data/content';
export function Objections() {
  return <section className="px-5 py-8" data-id="element-155" data-mp="mjphpgo64zr9">
      <div className="mx-auto max-w-xl" data-id="element-156" data-mp="mio3j3buvx5b">
        <h2 className="text-center font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-157" data-mp="mlsgoq7au384">
          Frequently Asked Questions
        </h2>

        <div className="mt-6 space-y-3" data-id="element-158" data-mp="cml3q44h8alj">
          {OBJECTIONS.map(o => <AccordionItem key={o.q} emoji="❓" title={o.q} data-id="element-159" data-mp="7uta1kq0xor6">
              <p className="text-sm leading-relaxed text-white/90" data-id="element-160" data-mp="7t8fvw7mg7tu">{o.a}</p>
            </AccordionItem>)}
        </div>

        {/* Support */}
        <div className="mt-8 flex flex-col items-center gap-2 rounded-2xl border border-white/20 bg-[#101b2d]/95 p-6 text-center shadow-lg shadow-black/20" data-id="element-161" data-mp="3v0tznooh36w9">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--pb-lime)]/15 text-[var(--pb-lime)]" data-id="element-162" data-mp="3l1l79099a0c0">
            <SettingsIcon size={26} data-id="element-163" data-mp="gqoiwhyejhs" />
          </div>
          <p className="text-sm font-600 text-white/80" data-id="element-164" data-mp="f5vxcf79amk">Support</p>
          <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-base font-700 text-[var(--pb-lime)] hover:underline" data-id="element-165" data-mp="58ihfdol11b3">
            <MailIcon size={16} data-id="element-166" data-mp="3rocy15rctg6k" />
            EbookDreamShop@gmail.com
          </a>
        </div>
      </div>
    </section>;
}